import { Box, Button, Typography, TextField, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Modal from 'react-modal';
import CustomRating from './Rating';




const RatingModal = ({ isModalOpen, handleModalClose, rating, setRating, comment, setComment, handleModalSubmit, isMobile, lngsltd }) => (
    <Dialog
        open={isModalOpen}       
        onClose={(event, reason) => {
            // Prevent closing if the click is outside or by pressing Escape
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                handleModalClose();
            }
        }}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
            sx: {
                width: isMobile ? '90%' : '50%',
                maxWidth: '400px',
                margin: 'auto',
                padding: 2,
                borderRadius: 2,
                boxShadow: 3,
            }
        }}
    >
        <DialogTitle>
            <Typography variant="h6" align="center">
                {lngsltd['How Would You Rate This Course?']}
            </Typography>
        </DialogTitle>
        <DialogContent>
            <Box
                p={1}
                display="flex"
                flexDirection="column"
                height="auto"
                maxWidth="90vw"
                maxHeight="90vh"
                overflow="auto"
                bgcolor="background.paper"
            >
                <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
                    <Box display="flex" justifyContent="center" mb={2}>
                        <CustomRating rating={rating} setRating={setRating} lngsltd={lngsltd} />
                    </Box>
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        placeholder={lngsltd['Leave a comment...']}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        fullWidth
                        sx={{ marginBottom: 2 }}
                    />
                </Box>
                <Box display="flex" justifyContent="space-between" mt={2}>
                    <Button variant="outlined" color="primary" onClick={handleModalClose}>
                        {lngsltd['Close']}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleModalSubmit(rating, comment)}
                        disabled={!rating}
                    >
                        {lngsltd['Submit']}
                    </Button>
                </Box>
            </Box>
        </DialogContent>
    </Dialog>
);

export default RatingModal;
